// The default workouts: the two starter workouts first (stable ids), then kettlebell, bodyweight and mobility, gym.
import type { Workout } from '../types';
import { BODYWEIGHT_WORKOUTS } from './bodyweight';
import { CARDIO_WORKOUTS } from './cardio';
import { GYM_WORKOUTS } from './gym';
import { KETTLEBELL_WORKOUTS } from './kettlebell';
import { STARTER_WORKOUTS } from './starter';

export const DEFAULT_WORKOUTS: Workout[] = [...STARTER_WORKOUTS, ...KETTLEBELL_WORKOUTS, ...BODYWEIGHT_WORKOUTS, ...GYM_WORKOUTS, ...CARDIO_WORKOUTS];
